import { ShineStartDocument } from '__generated__/GQL';
import asBentoPage from 'common/bento/hoc/asBentoPage';
import Callout from 'components/_core/Callout';
import Header from 'features/Onboarding/components/Header';
import OBFileItem from 'features/Onboarding/components/OBFileItem';
import OBNavigation from 'features/Onboarding/components/OBNavigation/OBNavigation';
import OBStickyButton from 'features/Onboarding/components/OBStickyButton/OBStickyButton';
import getShineStartDocumentError from 'features/Onboarding/modules/ShineStartVerification/libs/getShineStartDocumentError';
import getShineStartDocumentLabel from 'features/Onboarding/modules/ShineStartVerification/libs/getShineStartDocumentLabel';

import getDocumentLocales from '../../libs/getDocumentLocales';
import locales from './locales';

interface DocumentRefusedProps {
  onNext: () => void;
  document: ShineStartDocument;
}
const DocumentRefused = asBentoPage<DocumentRefusedProps>(
  ({ document, Layout, onNext, onPrev }) => {
    const { url } = document;

    if (!url) {
      throw Error('Document url should be defined');
    }

    const variableLocales = getDocumentLocales(document);
    const documentLabel = getShineStartDocumentLabel(document);

    const description =
      'documentDescription' in variableLocales
        ? variableLocales.documentDescription
        : undefined;

    return (
      <Layout nav={<OBNavigation onPrev={onPrev} />}>
        <Header
          description={description}
          title={variableLocales.documentName}
        />

        <Callout marginBottom="space-24" variant="error">
          <Callout.Content>
            {getShineStartDocumentError(document)}
          </Callout.Content>
        </Callout>

        <OBFileItem
          fileName={documentLabel}
          onPreviewClick={() => window.open(url, '_blank')}
        />

        <OBStickyButton icon="add-file" iconPosition="left" onClick={onNext}>
          {locales.replaceDocCta}
        </OBStickyButton>
      </Layout>
    );
  },
);

export default DocumentRefused;
